var User, addReferrer, fetchUser, my_stuff_layout_template, user_nav_template;

require('../../responsive_menu/frontend/view/responsive_menu');

addReferrer = require('../../../../../core/frontend/shared/userSessionAddReferrer');

user_nav_template = require('../vVERSION.html.mustache');

my_stuff_layout_template = require('../../../components/mystuff.html.mustache');

fetchUser = require('../../../../../src/frontend/helper/user/fetchUser').fetchUser;

module.exports = User = (function() {
  return {
    init: function() {
      var ref;
      if (!$('#ls-user-nav').length) {
        return;
      }
      this.translations = (ref = Groupon.LS.translations) != null ? ref.userNav : void 0;
      this.country_US = document.head.getAttribute('data-country') === 'US';
      return this.fetch();
    },
    fetch: function() {
      var error, hasUserData, hasUser_cb, noUser_cb, ref, success, userId;
      noUser_cb = function() {
        addReferrer.init();
      };
      hasUser_cb = (function(_this) {
        return function(res) {
          _this.renderUserNav(res);
          _this.renderMyStuff(res);
          Groupon.Modules.Header.bind();
          delete Groupon.Modules.Header;
        };
      })(this);
      success = hasUser_cb;
      ref = fetchUser.useStoredData(noUser_cb, hasUser_cb), userId = ref.userId, hasUserData = ref.hasUserData;
      if (hasUserData || !userId) {
        return;
      }
      error = function(err) {
        Groupon.Utils.trackEvent('user-call-failed', err);
      };
      return fetchUser.fetch(userId, success, error);
    },
    renderUserNav: function(user) {
      var data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
      data = {
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showLiteHeader: $('#ls-lite-header').length != null,
        enableBigSearch: $('.big-searchbar').length != null,
        showWishlist: ((ref = Groupon.LS.experiments) != null ? ref.showWishlist : void 0) && ($('#ls-lite-header').length != null),
        showMyPageUsersSubnav: (ref1 = Groupon.LS.experiments) != null ? ref1['LS-1237-MyPageUsersSubnav'] : void 0,
        showMerchantLinkHeader: (ref2 = Groupon.LS.experiments) != null ? ref2['LS-2601-HeaderMerchantLink'] : void 0,
        showReferAFriend: (ref3 = Groupon.LS.flags) != null ? ref3.showReferAFriend : void 0,
        referAFriendMessage: (ref4 = Groupon.LS.flags) != null ? ref4.referAFriendMessage : void 0,
        showMerchantCenterLink: (ref5 = Groupon.LS.flags) != null ? ref5.showMerchantCenterLink : void 0,
        showCart: (ref6 = Groupon.Cart) != null ? ref6.showCart : void 0
      };
      $('#ls-user-nav').html(user_nav_template.render(data));
      addReferrer.init();
      if ((ref7 = Cookie.get('has_cpp')) === '1' || ref7 === 'true') {
        $('#user-my-page').removeClass('hidden');
      }
      if ((ref8 = Groupon.PageFlags) != null ? ref8.isLegacyResponsive : void 0) {
        new Groupon.LS.Header.PNResponsiveMenu;
      }
      $('#sign-out, #ls-resp-sign-out').one('click', fetchUser.removeUserData);
    },
    renderMyStuff: function(user) {
      var $myStuffSelector, current, data, ref, ref1, ref2, ref3;
      if (!($myStuffSelector = $('#ls-my-stuff-wrapper')).length) {
        return;
      }
      current = Groupon.LS.CurrentMyStuffApp;
      data = {
        current: current,
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showMyFoodTab: (ref = Groupon.LS.flags) != null ? ref.showMyFoodTab : void 0,
        showMyEventsTab: (ref1 = Groupon.LS.flags) != null ? ref1.showMyEventsTab : void 0,
        showMyLinkedDealsTab: (ref2 = Groupon.LS.flags) != null ? ref2.showMyLinkedDealsTab : void 0,
        showMyReservations: (ref3 = Groupon.LS.flags) != null ? ref3.showMyReservations : void 0
      };
      return $myStuffSelector.html(my_stuff_layout_template.render(data));
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,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
